var User, addReferrer, fetchUser, my_stuff_layout_template, user_nav_template;

require('../../responsive_menu/frontend/view/responsive_menu');

addReferrer = require('../../../../../core/frontend/shared/userSessionAddReferrer');

user_nav_template = require('../vVERSION.html.mustache');

my_stuff_layout_template = require('../../../components/mystuff.html.mustache');

fetchUser = require('../../../../../src/frontend/helper/user/fetchUser').fetchUser;

module.exports = User = (function() {
  return {
    init: function() {
      var ref;
      if (!$('#ls-user-nav').length) {
        return;
      }
      this.translations = (ref = Groupon.LS.translations) != null ? ref.userNav : void 0;
      this.country_US = document.head.getAttribute('data-country') === 'US';
      return this.fetch();
    },
    fetch: function() {
      var error, hasUserData, hasUser_cb, noUser_cb, ref, success, userId;
      noUser_cb = function() {
        addReferrer.init();
      };
      hasUser_cb = (function(_this) {
        return function(res) {
          _this.renderUserNav(res);
          _this.renderMyStuff(res);
          Groupon.Modules.Header.bind();
          delete Groupon.Modules.Header;
        };
      })(this);
      success = hasUser_cb;
      ref = fetchUser.useStoredData(noUser_cb, hasUser_cb), userId = ref.userId, hasUserData = ref.hasUserData;
      if (hasUserData || !userId) {
        return;
      }
      error = function(err) {
        Groupon.Utils.trackEvent('user-call-failed', err);
      };
      return fetchUser.fetch(userId, success, error);
    },
    renderUserNav: function(user) {
      var data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
      data = {
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showLiteHeader: $('#ls-lite-header').length != null,
        enableBigSearch: $('.big-searchbar').length != null,
        showWishlist: ((ref = Groupon.LS.experiments) != null ? ref.showWishlist : void 0) && ($('#ls-lite-header').length != null),
        showMyPageUsersSubnav: (ref1 = Groupon.LS.experiments) != null ? ref1['LS-1237-MyPageUsersSubnav'] : void 0,
        showMerchantLinkHeader: (ref2 = Groupon.LS.experiments) != null ? ref2['LS-2601-HeaderMerchantLink'] : void 0,
        showReferAFriend: (ref3 = Groupon.LS.flags) != null ? ref3.showReferAFriend : void 0,
        referAFriendMessage: (ref4 = Groupon.LS.flags) != null ? ref4.referAFriendMessage : void 0,
        showMerchantCenterLink: (ref5 = Groupon.LS.flags) != null ? ref5.showMerchantCenterLink : void 0,
        showCart: (ref6 = Groupon.Cart) != null ? ref6.showCart : void 0
      };
      $('#ls-user-nav').html(user_nav_template.render(data));
      addReferrer.init();
      if ((ref7 = Cookie.get('has_cpp')) === '1' || ref7 === 'true') {
        $('#user-my-page').removeClass('hidden');
      }
      if ((ref8 = Groupon.PageFlags) != null ? ref8.isLegacyResponsive : void 0) {
        new Groupon.LS.Header.PNResponsiveMenu;
      }
      $('#sign-out, #ls-resp-sign-out').one('click', fetchUser.removeUserData);
    },
    renderMyStuff: function(user) {
      var $myStuffSelector, current, data, ref, ref1, ref2, ref3;
      if (!($myStuffSelector = $('#ls-my-stuff-wrapper')).length) {
        return;
      }
      current = Groupon.LS.CurrentMyStuffApp;
      data = {
        current: current,
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showMyFoodTab: (ref = Groupon.LS.flags) != null ? ref.showMyFoodTab : void 0,
        showMyEventsTab: (ref1 = Groupon.LS.flags) != null ? ref1.showMyEventsTab : void 0,
        showMyLinkedDealsTab: (ref2 = Groupon.LS.flags) != null ? ref2.showMyLinkedDealsTab : void 0,
        showMyReservations: (ref3 = Groupon.LS.flags) != null ? ref3.showMyReservations : void 0
      };
      return $myStuffSelector.html(my_stuff_layout_template.render(data));
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,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
